var User, addReferrer, fetchUser, my_stuff_layout_template, user_nav_template;

require('../../responsive_menu/frontend/view/responsive_menu');

addReferrer = require('../../../../../core/frontend/shared/userSessionAddReferrer');

user_nav_template = require('../vVERSION.html.mustache');

my_stuff_layout_template = require('../../../components/mystuff.html.mustache');

fetchUser = require('../../../../../src/frontend/helper/user/fetchUser').fetchUser;

module.exports = User = (function() {
  return {
    init: function() {
      var ref;
      if (!$('#ls-user-nav').length) {
        return;
      }
      this.translations = (ref = Groupon.LS.translations) != null ? ref.userNav : void 0;
      this.country_US = document.head.getAttribute('data-country') === 'US';
      return this.fetch();
    },
    fetch: function() {
      var error, hasUserData, hasUser_cb, noUser_cb, ref, success, userId;
      noUser_cb = function() {
        addReferrer.init();
      };
      hasUser_cb = (function(_this) {
        return function(res) {
          _this.renderUserNav(res);
          _this.renderMyStuff(res);
          Groupon.Modules.Header.bind();
          delete Groupon.Modules.Header;
        };
      })(this);
      success = hasUser_cb;
      ref = fetchUser.useStoredData(noUser_cb, hasUser_cb), userId = ref.userId, hasUserData = ref.hasUserData;
      if (hasUserData || !userId) {
        return;
      }
      error = function(err) {
        Groupon.Utils.trackEvent('user-call-failed', err);
      };
      return fetchUser.fetch(userId, success, error);
    },
    renderUserNav: function(user) {
      var data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
      data = {
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showLiteHeader: $('#ls-lite-header').length != null,
        enableBigSearch: $('.big-searchbar').length != null,
        showWishlist: ((ref = Groupon.LS.experiments) != null ? ref.showWishlist : void 0) && ($('#ls-lite-header').length != null),
        showMyPageUsersSubnav: (ref1 = Groupon.LS.experiments) != null ? ref1['LS-1237-MyPageUsersSubnav'] : void 0,
        showMerchantLinkHeader: (ref2 = Groupon.LS.experiments) != null ? ref2['LS-2601-HeaderMerchantLink'] : void 0,
        showReferAFriend: (ref3 = Groupon.LS.flags) != null ? ref3.showReferAFriend : void 0,
        referAFriendMessage: (ref4 = Groupon.LS.flags) != null ? ref4.referAFriendMessage : void 0,
        showMerchantCenterLink: (ref5 = Groupon.LS.flags) != null ? ref5.showMerchantCenterLink : void 0,
        showCart: (ref6 = Groupon.Cart) != null ? ref6.showCart : void 0
      };
      $('#ls-user-nav').html(user_nav_template.render(data));
      addReferrer.init();
      if ((ref7 = Cookie.get('has_cpp')) === '1' || ref7 === 'true') {
        $('#user-my-page').removeClass('hidden');
      }
      if ((ref8 = Groupon.PageFlags) != null ? ref8.isLegacyResponsive : void 0) {
        new Groupon.LS.Header.PNResponsiveMenu;
      }
      $('#sign-out, #ls-resp-sign-out').one('click', fetchUser.removeUserData);
    },
    renderMyStuff: function(user) {
      var $myStuffSelector, current, data, ref, ref1, ref2, ref3;
      if (!($myStuffSelector = $('#ls-my-stuff-wrapper')).length) {
        return;
      }
      current = Groupon.LS.CurrentMyStuffApp;
      data = {
        current: current,
        user: user,
        t: this.translations,
        country_US: this.country_US,
        showMyFoodTab: (ref = Groupon.LS.flags) != null ? ref.showMyFoodTab : void 0,
        showMyEventsTab: (ref1 = Groupon.LS.flags) != null ? ref1.showMyEventsTab : void 0,
        showMyLinkedDealsTab: (ref2 = Groupon.LS.flags) != null ? ref2.showMyLinkedDealsTab : void 0,
        showMyReservations: (ref3 = Groupon.LS.flags) != null ? ref3.showMyReservations : void 0
      };
      return $myStuffSelector.html(my_stuff_layout_template.render(data));
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,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
